<template>
  <div class="footer"
       :class="{'page1': $route.path === '/page/1', 'page3': $route.path === '/page/3'}">
    <p>Copyright © 2019 优托邦 版权所有 保留一切权利 <a href="https://beian.miit.gov.cn"
         target="_Blank">{{ ICP }}</a> </p>
  </div>
</template>
<script>
export default {
  name: '',
  components: {},
  props: {},
  data () {
    return {
      domainMap: {
        'www.utopa.com.cn': '粤ICP备16040467号',
        'www.myutopa.com': '粤ICP备17150681号',
        'www.myutopa.com.cn': '粤ICP备17150681号',
        'www.utopaparking.com': '粤ICP备17150681号',
        'utopaparking.com': '粤ICP备17150681号',
        'www.myutopa.net': '粤ICP备17150681号',
        'myutopa.net': '粤ICP备17150681号'
      },
      ICP: '粤ICP备20017082号'
    }
  },
  created () {
    // this.ICP = this.getICP() || '粤ICP备17150681号'
  },
  methods: {
    getCurDomain (url) {
      let domain
      // eslint-disable-next-line no-useless-escape
      const domainRegExp = /:\/\/([^\/]+)\//i
      try {
        domain = url.match(domainRegExp)[1]
      } catch (e) { }
      return domain
    },
    getICP () {
      const domain = this.getCurDomain(window.location.href)
      return this.domainMap[domain]
    }
  },
  computed: {}
}
</script>

<style scoped lang="scss">
.footer {
  width: 90%;
  margin: 0 auto 5px;
  // background-color: #ffffff;
  p {
    text-align: center;
    padding: 0;
    margin: 0;
    font-size: 14px;
    color: #222222;
    a {
      color: rgb(42, 123, 199);
      text-decoration: none;
      margin-left: 10px;
    }
  }
}
.page1 {
  margin-top: 80px;
}
.page3 {
  margin-top: 70px;
}
</style>
